import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraSelect, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../../lib/connect/clients';
import { useCompanyProfiles } from '../../Delivery/Programs/referenceDataHooks';
import { TextField } from '../PastPerformance/Fields';
export const isIntelligenceOutput = (template)=>template === 'black-hat-report-v1' || template === 'executive-brief-v1';
export function OutputContextFields({ captureProjectId, value, onChange }) {
    const ids = Testids.captureOutputContext;
    const list = useQuery({
        queryKey: [
            'black-hat',
            captureProjectId
        ],
        queryFn: ()=>projectDataClient.listBlackHatAssessments({
                pursuitId: captureProjectId
            }),
        retry: false
    });
    const companies = useCompanyProfiles();
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                children: "Select the assessments to include. Each selected assessment’s exact version is frozen. Pricing and a numeric model are optional."
            }),
            /*#__PURE__*/ _jsx(TextField, {
                label: "Purpose",
                testId: ids.purpose,
                value: value.purpose,
                onChange: (purpose)=>onChange({
                        ...value,
                        purpose
                    })
            }),
            /*#__PURE__*/ _jsx(TextField, {
                label: "Audience",
                testId: ids.audience,
                value: value.audience,
                onChange: (audience)=>onChange({
                        ...value,
                        audience
                    })
            }),
            list.isPending ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                children: "Loading assessments…"
            }) : list.isError ? /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                role: "alert",
                children: [
                    "Assessments could not be loaded.",
                    ' ',
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        onClick: ()=>list.refetch(),
                        children: "Retry assessments"
                    })
                ]
            }) : !list.data?.assessments.length ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                children: "No assessments yet. Record qualitative findings in Black Hat below, then select the assessment here."
            }) : /*#__PURE__*/ _jsx(SpecraSelect, {
                "aria-label": "Selected assessment scope",
                "data-testid": ids.scope,
                multiple: true,
                value: value.participantIds,
                onChange: (event)=>onChange({
                        ...value,
                        participantIds: Array.from(event.target.selectedOptions, (option)=>option.value)
                    }),
                children: list.data.assessments.map((assessment)=>/*#__PURE__*/ _jsxs("option", {
                        value: assessment.participantId,
                        children: [
                            companies.data?.find((company)=>company.id === assessment.companyProfileId)?.name || 'Competitor',
                            ' ',
                            "· assessment version ",
                            assessment.version
                        ]
                    }, assessment.participantId))
            })
        ]
    });
}
export function FrozenOutputContext({ context }) {
    if (!context) return null;
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                children: [
                    "Purpose: ",
                    context.purpose
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                children: [
                    "Audience: ",
                    context.audience
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                children: [
                    "Selected assessment scope: ",
                    context.participantIds.join('; ')
                ]
            })
        ]
    });
}
